import React from 'react';
import { products } from '../mock';
import { ShoppingBag, Star } from 'lucide-react';
import { useCart } from '../context/CartContext';

const Products = () => {
  const { add } = useCart();

  return (
    <section id="products" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-12 gap-4">
          <div>
            <div className="text-sm tracking-[0.2em] uppercase text-[#c9743a] mb-3">Shop</div>
            <h2 className="font-serif text-4xl lg:text-5xl text-[#1a2b17] tracking-tight">
              NutrifyMe wellness range
            </h2>
          </div>
          <p className="text-[#4a5544] max-w-md">
            Small-batch, science-backed products crafted to complement your
            personalised nutrition plan.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {products.map((p) => (
            <div key={p.id} className="group relative bg-[#faf7f1] rounded-3xl overflow-hidden hover:shadow-xl transition-all duration-500">
              <div className="relative aspect-square overflow-hidden">
                <img src={p.image} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                {p.tag && (
                  <div className="absolute top-3 left-3 bg-[#c9743a] text-white text-[10px] tracking-widest uppercase px-3 py-1 rounded-full">
                    {p.tag}
                  </div>
                )}
                <button
                  onClick={() => add(p)}
                  className="absolute bottom-3 right-3 w-11 h-11 rounded-full bg-white shadow-md flex items-center justify-center opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300 hover:bg-[#3a5a2c] hover:text-white"
                >
                  <ShoppingBag className="w-4 h-4" />
                </button>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-1 mb-2">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-3 h-3 fill-[#e8a94b] text-[#e8a94b]" />
                  ))}
                </div>
                <h3 className="text-sm font-medium text-[#1a2b17] leading-snug min-h-[2.5rem]">
                  {p.name}
                </h3>
                <div className="mt-3 flex items-center justify-between">
                  <span className="font-serif text-lg text-[#1a2b17]">₹{p.price}</span>
                  <span className="text-xs text-[#7a8471] line-through">₹{p.price + 100}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
